/* global google, GMaps */
import mapStyles from '../../util/mapStyles';

const venueLocationMap = () => {
  jQuery(document).ready(function($) {
    const locationMapSection = $('section.common-hotel-venue-location-map-section');
    if (locationMapSection.length) {
      const mapDiv = locationMapSection.find('#map');
      if (mapDiv.length) {
        const title = mapDiv.data('title');
        const address = mapDiv.data('address');
        const locationLat = mapDiv.data('lat');
        const locationLng = mapDiv.data('lng');
        const markerUrl = mapDiv.data('marker-url');
        const infoWindowTemplate = locationMapSection.find('#map-marker-info-window').html();

        const transformMapInfo = function(data, template) {
          const keys = [];
          const values = [];

          $.each(data, function (key, value) {
            keys.push(key);
            values.push(value);
          });

          for (let i = 0; i < keys.length; i++) {
            template = template.replace(new RegExp('--' + keys[i] + '--', 'g'), values[i]);
          }

          return template;
        };

        const map = new GMaps({
          div: '#map',
          scrollwheel: false,
          lat: locationLat,
          lng: locationLng,
          zoom: 13,
          styles: mapStyles,
        });

        map.addMarker({
          lat: locationLat,
          lng: locationLng,
          title: title,
          icon: {
            scaledSize: new google.maps.Size(42, 42),
            url: markerUrl,
          },
          infoWindow: {
            'content': transformMapInfo({
              name: title,
              address: address,
            }, infoWindowTemplate),
          },
          click() {
            setTimeout(() => {
              // Remove info window arrow
              const gmStyleIw = $('.gm-style-iw');
              const gmArrow = gmStyleIw.prev().find('div').eq(2);
              gmArrow.parent().find('div').eq(0).hide();
              gmArrow.hide();
            }, 10);
          },
        });
      }
    }
  });
};

export default venueLocationMap;



// WEBPACK FOOTER //
// ./scripts/routes/modules/venueLocationMap.js